export default __webpack_public_path__ + "static/media/stands_ind_-ledvance.387fb851.jpg";